// Load Active Admin's styles into Webpacker,
// see `active_admin.scss` for customization.

require("trix")
require("@rails/actiontext")

import "../stylesheets/active_admin"

import "@activeadmin/activeadmin"

import "activeadmin_addons"

import './bootstrap_modal'

import "@fortawesome/fontawesome-free/css/all.css"

import './accident_party/party_type_dynamic_inputs'

import './confirm_logout_popup'

import './tp_claim_intimations/back_button'

import './beneficiary/bank_nationality_dynamic_inputs'

import './tp_claim_intimations/fraud_dynamic_inputs'

import './tp_claim_intimations/recovery_dynamic_inputs'

import './tp_claim_intimations/damage_assessment_dynamic_inputs'

import './damage_assessment/damage_assessment_dynamic_inputs'

import './survey_request/surveyor_decision_dynamic_inputs'

import './survey_request/audatex_report_dynamic_inputs'

import './repair_quotation/calculations_dynamic_inputs'

import './zero_cash_proposal/dynamic_inputs'

import './car_replacement_request/dynamic_inputs'

import './insured/insured_type_dynamic_inputs'

import './image_hints_reformatter'

import './modal_handler'

import './tabs_link_mirroring'

import './row_hider'

import './character_counter'

import './add_notes_action_item_handler'

import './content_input_required_astrik_hider'

// import './bugsnag_initializer'

// TODO: improve below performance
import './dashboard_dynamic_formatting'
